import $ from 'jquery';
import eventBus from './eventBus';


function Checkboxes($el){
	this.$el = $el;
	this.$cb = this.$el.find('[data-cb]');
	this.init();
}

Checkboxes.prototype = {
	init: function(){
		var _this = this;
		this.$cb.on('change',function(){
			_this.checboxIterator(_this.toggleVisible);
		});
		if(this.$cb.prop('checked')){
			_this.checboxIterator(_this.showCheckboxes);
		}

	},

	checboxIterator: function(fn){
		var selectors = this.$cb.data('cb').split(',');
		$.each(selectors,$.proxy(fn,this));
	},

	toggleVisible: function(i,selector){
		this.$el.find('[data-xp="'+selector+'"]').toggleClass('hide').find('input[type="checkbox"]').prop('checked',false);
	},

	showCheckboxes: function(i,selector){
		this.$el.find('[data-xp="'+selector+'"]').removeClass('hide').find('input[type="checkbox"]');
	},

	destroy: function(){
		this.$cb.off('change');
	}

}

var checkboxes = [];

$(document).ready(()=> {

	
	var $cb = $('[data-js="cbs"]');

	
	$cb.length && init($cb);
	
	eventBus.on('ajaxForm',function(){
		init();
	});
})

function init($cb) {
	$.each(checkboxes,destroy);
	checkboxes = [];

	$cb.each(function(){
		checkboxes.push(new Checkboxes($(this)));
	});
}

function destroy(){
	this.destroy();
}